import styled from 'styled-components/native';

export const BackGroundImageView = styled.ImageBackground`
  flex: 1;
  padding: 15px 25px;
  align-items: center;
  justify-content: center;
  background-color: rgba(22, 18, 51, 0.3);
`;
